import { Transaction } from 'types/transaction';

export default function makeData(): Transaction[] {
    return generateRandomTransactions(100);
}

// Helper functions to generate random data
const getRandomInt = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

const getRandomDate = (start: Date = new Date(2019, 0, 1), end: Date = new Date()): Date => {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

const formatDate = (date: Date): string => {
    return date.toISOString();
};

const formatCurrency = (min: number, max: number): number => {
    return parseFloat((Math.random() * (max - min) + min).toFixed(2));
};

// Generate a random string of specified length
const getRandomString = (length = 10, prefix = ''): string => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const randomChars = Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    return prefix ? `${prefix}-${randomChars}` : randomChars;
};

// Main generator function
function generateRandomTransactions(count: number): Transaction[] {
    const transactions: Transaction[] = [];

    for (let i = 0; i < count; i++) {
        const facilityID = getRandomInt(20, 30);
        const dateOfService = getRandomDate(new Date(2020, 0, 1), new Date(2023, 11, 31));
        const patientDOB = getRandomDate(new Date(1930, 0, 1), new Date(2000, 11, 31));

        // Generate financial data
        const charge = formatCurrency(100, 10000);
        const adj = formatCurrency(0, charge * 0.3);
        const pmtInsCo = formatCurrency(0, charge * 0.7);
        const pmtPat = formatCurrency(0, charge * 0.2);
        const balance = parseFloat((charge - adj - pmtInsCo - pmtPat).toFixed(2));
        const colBal = balance > 0 ? formatCurrency(0, balance) : 0;

        // Generate random identifiers
        const firstName = getRandomString(8);
        const lastName = getRandomString(10);

        const transaction: Transaction = {
            invoiceNo: getRandomString(5, 'INV'),
            srcSystemKey: getRandomString(4, 'SSK'),
            facilityName: getRandomString(12, 'FAC'),
            facilityID,
            hospitalAccountNumber: getRandomString(6, 'HA'),
            mrn: getRandomString(6, 'MRN'),
            statementAccount: getRandomString(5, 'SA'),
            firstName,
            lastName,
            dob: formatDate(patientDOB),
            dos: formatDate(dateOfService),
            ados: formatDate(dateOfService),
            charge,
            adj,
            pmtInsCo,
            pmtPat,
            balance,
            colBal,
            insuranceCompany: getRandomString(15),
            policyID: getRandomString(8, 'POL')
        };

        transactions.push(transaction);
    }

    return transactions;
} 